<template>
  <component :is="Default">
    <!-- Header -->
    <template slot="buttons">
      <div class="buttons">
        <button class="loose thin" @click="back">Back</button>
        <button class="loose transparent thin" @click="$logout">log out</button>
      </div>
    </template>
    <!--    body -->
    <Match v-if="currentMatch" :match="currentMatch" class="rel"> </Match>
    <div class="justify-center">
      <section
        v-if="
          this.currentMatch &&
            this.currentMatch.scoringEvents &&
            this.currentMatch.scoringEvents.length > 0
        "
        class="card scores"
      >
        <section
          v-if="tries.home.length > 0 || tries.away.length > 0"
          class="section"
        >
          <div class="row">
            <div class="score">{{ tries.home.length }}</div>
            <div class="heading"><h3>Tries</h3></div>
            <div class="score">{{ tries.away.length }}</div>
          </div>
          <div class="row">
            <div class="detail">
              <div v-for="(event, i) in tries.home" :key="i">
                {{ event.meta.player.firstName }}
                {{ event.meta.player.lastName }}
                {{ event.min }}'
              </div>
            </div>
            <div class="detail">
              <div v-for="(event, i) in tries.away" :key="i">
                {{ event.min }}'
                {{ event.meta.player.firstName }}
                {{ event.meta.player.lastName }}
              </div>
            </div>
          </div>
        </section>
        <section
          v-if="conversions.home.length > 0 || conversions.away.length > 0"
          class="section"
        >
          <div class="row">
            <div class="score">
              {{ conversions.home.length }}/{{ conversionAttempts.home }}
            </div>
            <div class="heading"><h3>Conversions</h3></div>
            <div class="score">
              {{ conversions.away.length }}/{{ conversionAttempts.away }}
            </div>
          </div>
          <div class="row">
            <div class="detail">
              <div v-for="(event, i) in conversions.home" :key="i">
                {{ event.meta.player.firstName }}
                {{ event.meta.player.lastName }}
                {{ event.min }}'
              </div>
            </div>
            <div class="detail">
              <div v-for="(event, i) in conversions.away" :key="i">
                {{ event.min }}'
                {{ event.meta.player.firstName }}
                {{ event.meta.player.lastName }}
              </div>
            </div>
          </div>
        </section>
        <section
          v-if="penaltyGoals.home.length > 0 || penaltyGoals.away.length > 0"
          class="section"
        >
          <div class="row">
            <div class="score">
              {{ penaltyGoals.home.length }}/{{ penaltyAttempts.home }}
            </div>
            <div class="heading"><h3>Penalty Goals</h3></div>
            <div class="score">
              {{ penaltyGoals.away.length }}/{{ penaltyAttempts.away }}
            </div>
          </div>
          <div class="row">
            <div class="detail">
              <div v-for="(event, i) in penaltyGoals.home" :key="i">
                {{ event.meta.player.firstName }}
                {{ event.meta.player.lastName }}
                {{ event.min }}'
              </div>
            </div>
            <div class="detail">
              <div v-for="(event, i) in penaltyGoals.away" :key="i">
                {{ event.min }}'
                {{ event.meta.player.firstName }}
                {{ event.meta.player.lastName }}
              </div>
            </div>
          </div>
        </section>
        <section
          v-if="fieldGoals.home.length > 0 || fieldGoals.away.length > 0"
          class="section"
        >
          <div class="row">
            <div class="score">
              {{ fieldGoals.home.length }}/{{ fieldAttempts.home }}
            </div>
            <div class="heading"><h3>Field Goals</h3></div>
            <div class="score">
              {{ fieldGoals.away.length }}/{{ fieldAttempts.away }}
            </div>
          </div>
          <div class="row">
            <div class="detail">
              <div v-for="(event, i) in fieldGoals.home" :key="i">
                {{ event.meta.player.firstName }}
                {{ event.meta.player.lastName }}
                {{ event.min }}'
              </div>
            </div>
            <div class="detail">
              <div v-for="(event, i) in fieldGoals.away" :key="i">
                {{ event.min }}'
                {{ event.meta.player.firstName }}
                {{ event.meta.player.lastName }}
              </div>
            </div>
          </div>
        </section>
      </section>
      <section v-if="currentMatch" class="card tabbed">
        <ul class="tablist" role="tablist">
          <li
            id="tab1"
            class="tab"
            aria-controls="panel1"
            :aria-selected="selectedTab === 1"
            tabindex="0"
            @click="selectedTab = 1"
            @keyup.enter="selectedTab = 1"
          >
            Team Lists
          </li>
          <li
            id="tab2"
            class="tab"
            aria-controls="panel2"
            :aria-selected="selectedTab === 2"
            tabindex="0"
            @click="selectedTab = 2"
            @keyup.enter="selectedTab = 2"
          >
            Interchanges
          </li>
        </ul>
        <div
          id="panel1"
          class="panel"
          aria-labelledby="tab1"
          role="tabpanel"
          :aria-hidden="selectedTab === 2"
        >
          <table class="desktop">
            <thead>
              <tr>
                <th scope="col">
                  {{ currentMatch.homeTeam.name }}
                </th>
                <th></th>
                <th scope="col">
                  {{ currentMatch.awayTeam.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="currentMatch.homeListData || currentMatch.awayListData">
                <td>
                  <div v-if="currentMatch.homeListData" class="tl-data">
                    {{ currentMatch.homeListData.status }}
                    {{
                      currentMatch.homeListData.modifiedAt
                        ? matchTime(currentMatch.homeListData.modifiedAt)
                        : matchTime(currentMatch.homeListData.createdAt)
                    }}
                    <br />
                    {{
                      currentMatch.homeListData.modifiedAt
                        ? matchDate(currentMatch.homeListData.modifiedAt)
                        : matchDate(currentMatch.homeListData.createdAt)
                    }}
                  </div>
                </td>
                <td></td>
                <td>
                  <div v-if="currentMatch.awayListData" class="tl-data">
                    {{ currentMatch.awayListData.status }}
                    {{
                      currentMatch.awayListData.modifiedAt
                        ? matchTime(currentMatch.awayListData.modifiedAt)
                        : matchTime(currentMatch.awayListData.createdAt)
                    }}
                    <br />
                    {{
                      currentMatch.awayListData.modifiedAt
                        ? matchDate(currentMatch.awayListData.modifiedAt)
                        : matchDate(currentMatch.awayListData.createdAt)
                    }}
                  </div>
                </td>
              </tr>
              <tr
                v-for="(position, i) in currentMatch.competitionSetting
                  .positions"
                :key="i"
              >
                <td>{{ getHomePlayer(position) }}</td>
                <td>{{ position.name }}</td>
                <td>{{ getAwayPlayer(position) }}</td>
              </tr>
            </tbody>
          </table>
          <table class="mobile">
            <thead>
              <tr>
                <th colspan="2" scope="col">
                  {{ currentMatch.homeTeam.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="currentMatch.homeListData">
                <td colspan="2">
                  <div class="tl-data">
                    {{ currentMatch.homeListData.status }}
                    {{
                      currentMatch.homeListData.modifiedAt
                        ? matchTime(currentMatch.homeListData.modifiedAt)
                        : matchTime(currentMatch.homeListData.createdAt)
                    }}
                    <br />
                    {{
                      currentMatch.homeListData.modifiedAt
                        ? matchDate(currentMatch.homeListData.modifiedAt)
                        : matchDate(currentMatch.homeListData.createdAt)
                    }}
                  </div>
                </td>
              </tr>
              <tr
                v-for="(position, i) in currentMatch.competitionSetting
                  .positions"
                :key="i"
              >
                <td>{{ position.name }}</td>
                <td>{{ getHomePlayer(position) }}</td>
              </tr>
            </tbody>
          </table>
          <table class="mobile">
            <thead>
              <tr>
                <th colspan="2" scope="col">
                  {{ currentMatch.awayTeam.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="currentMatch.awayListData">
                <td colspan="2">
                  <div class="tl-data">
                    {{ currentMatch.awayListData.status }}
                    {{
                      currentMatch.awayListData.modifiedAt
                        ? matchTime(currentMatch.awayListData.modifiedAt)
                        : matchTime(currentMatch.awayListData.createdAt)
                    }}
                    <br />
                    {{
                      currentMatch.awayListData.modifiedAt
                        ? matchDate(currentMatch.awayListData.modifiedAt)
                        : matchDate(currentMatch.awayListData.createdAt)
                    }}
                  </div>
                </td>
              </tr>
              <tr
                v-for="(position, i) in currentMatch.competitionSetting
                  .positions"
                :key="i"
              >
                <td>{{ position.name }}</td>
                <td>{{ getAwayPlayer(position) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          id="panel2"
          class="panel"
          aria-labelledby="tab2"
          role="tabpanel"
          :aria-hidden="selectedTab === 1"
        >
          <div class="mobile-header">
            {{ currentMatch.homeTeam.name }}
          </div>
          <div class="column">
            <div
              v-for="(interchange, i) in playerMovements.home"
              :key="i"
              class="interchange"
            >
              <div class="d-flex-column">
                <div v-if="interchange.number" class="counts">
                  {{ interchange.number }}
                </div>
                <div class="time">
                  {{ interchange.min }}:{{ interchange.sec }}
                </div>
              </div>
              <div class="d-flex-column">
                <div class="header">{{ interchange.name }}</div>
                <div v-if="interchange.meta.on" class="player">
                  On:
                  <span
                    >{{ interchange.meta.on.firstName }}
                    {{ interchange.meta.on.lastName }}</span
                  >
                </div>
                <div v-if="interchange.meta.off" class="player">
                  Off: {{ interchange.meta.off.firstName }}
                  {{ interchange.meta.off.lastName }}
                </div>
              </div>
            </div>
          </div>
          <div class="column mobile-header">
            {{ currentMatch.awayTeam.name }}
          </div>
          <div class="column">
            <div
              v-for="(interchange, i) in playerMovements.away"
              :key="i"
              class="interchange"
            >
              <div class="d-flex-column">
                <div v-if="interchange.number" class="counts">
                  {{ interchange.number }}
                </div>
                <div class="time">
                  {{ interchange.min }}:{{ interchange.sec }}
                </div>
              </div>
              <div class="d-flex-column">
                <div class="header">{{ interchange.name }}</div>
                <div v-if="interchange.meta.on" class="player">
                  On:
                  <span
                    >{{ interchange.meta.on.firstName }}
                    {{ interchange.meta.on.lastName }}</span
                  >
                </div>
                <div v-if="interchange.meta.off" class="player">
                  Off: {{ interchange.meta.off.firstName }}
                  {{ interchange.meta.off.lastName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </component>
</template>

<script>
import Default from "@/layouts/default";
import Match from "@/components/MatchCard";
import moment from "moment";

export default {
  name: "matchevents",
  components: {
    Match,
  },
  data() {
    return {
      timer: "",
      Default,
      selectedTab: 1,
      // Event
      type: undefined,
      // Player
      selected: undefined,
      isHomeTeam: undefined,
      // Modals and helpers
      selecting: false,
      period: undefined,
      enterMatchTimeModalDisplayed: false,
      feedDisplayed: false,
      networkOnline: true,
      apiRequestFailed: false,
      blockSendEvents: false,
      blockRedirectConfirm: false,
    };
  },
  mounted() {
    this.blockSendEvents = true;
    const { id } = this.$route.params;
    this.getMatch(id);
    this.timer = setInterval(this.getMatch, 300000, id);
  },
  computed: {
    currentMatch() {
      return this.$store.state.match.currentMatch;
    },
    currentHomeTeam() {
      return (
        this.$store.state.match.currentMatch &&
        this.$store.state.match.currentMatch.homeList &&
        this.$store.state.match.currentMatch.homeList.length > 0 &&
        this.$store.state.match.currentMatch.homeList.filter(
          (p) => p.type === "player",
        )
      );
    },
    currentAwayTeam() {
      return (
        this.$store.state.match.currentMatch &&
        this.$store.state.match.currentMatch.awayList &&
        this.$store.state.match.currentMatch.awayList.length > 0 &&
        this.$store.state.match.currentMatch.awayList.filter(
          (p) => p.type === "player",
        )
      );
    },
    scoringEvents() {
      return this.$store.state.match.currentMatch &&
        this.$store.state.match.currentMatch.scoringEvents
        ? this.$store.state.match.currentMatch.scoringEvents
        : [];
    },
    tries() {
      return {
        home: this.scoringEvents.filter(
          (e) =>
            e.isHomeTeam === true &&
            (e.type === 38 || e.type === 99 || e.type === 102),
        ),
        away: this.scoringEvents.filter(
          (e) =>
            e.isHomeTeam === false &&
            (e.type === 38 || e.type === 99 || e.type === 102),
        ),
      };
    },
    conversionAttempts() {
      return {
        home: this.scoringEvents.filter(
          (e) => e.isHomeTeam === true && (e.type === 1 || e.type === 2),
        ).length,
        away: this.scoringEvents.filter(
          (e) => e.isHomeTeam === false && (e.type === 1 || e.type === 2),
        ).length,
      };
    },
    conversions() {
      return {
        home: this.scoringEvents.filter(
          (e) => e.isHomeTeam === true && e.type === 1,
        ),
        away: this.scoringEvents.filter(
          (e) => e.isHomeTeam === false && e.type === 1,
        ),
      };
    },
    penaltyAttempts() {
      return {
        home: this.scoringEvents.filter(
          (e) => e.isHomeTeam === true && (e.type === 67 || e.type === 68),
        ).length,
        away: this.scoringEvents.filter(
          (e) => e.isHomeTeam === false && (e.type === 67 || e.type === 68),
        ).length,
      };
    },
    penaltyGoals() {
      return {
        home: this.scoringEvents.filter(
          (e) => e.isHomeTeam === true && e.type === 67,
        ),
        away: this.scoringEvents.filter(
          (e) => e.isHomeTeam === false && e.type === 67,
        ),
      };
    },
    fieldAttempts() {
      return {
        home: this.scoringEvents.filter(
          (e) => e.isHomeTeam === true && (e.type === 69 || e.type === 70),
        ).length,
        away: this.scoringEvents.filter(
          (e) => e.isHomeTeam === false && (e.type === 69 || e.type === 70),
        ).length,
      };
    },
    fieldGoals() {
      return {
        home: this.scoringEvents.filter(
          (e) => e.isHomeTeam === true && e.type === 69,
        ),
        away: this.scoringEvents.filter(
          (e) => e.isHomeTeam === false && e.type === 69,
        ),
      };
    },
    playerMovements() {
      const allMovements =
        this.$store.state.match.currentMatch &&
        this.$store.state.match.currentMatch.playerMovements
          ? this.$store.state.match.currentMatch.playerMovements
          : [];
      let homeCounts = 0;
      let awayCounts = 0;
      return {
        home: allMovements
          .filter((m) => m.isHomeTeam === true)
          // eslint-disable-next-line prettier/prettier
          .sort((m1, m2) => m1.min + m1.sec / 60 - (m2.min + m2.sec / 60))
          .map((m) => {
            if (m.interchangeCounts == true) {
              homeCounts += 1;
              return Object.assign(m, { number: homeCounts });
            }
            return m;
          })
          .reverse(),
        away: allMovements
          .filter((m) => m.isHomeTeam === false)
          // eslint-disable-next-line prettier/prettier
          .sort((m1, m2) => m1.min + m1.sec / 60 - (m2.min + m2.sec / 60))
          .map((m) => {
            if (m.interchangeCounts == true) {
              awayCounts += 1;
              return Object.assign(m, { number: awayCounts });
            }
            return m;
          })
          .reverse(),
      };
    },
    periodLength() {
      return this.currentMatch.competition.periodLength
        ? this.currentMatch.competition.periodLength
        : 40;
    },
  },
  methods: {
    getMatch(id) {
      this.$store.commit("LOADING", true);
      this.$http
        .get(`/nrl/api/v1/elite/matches/embargo/${id}`)
        .then((response) => {
          if (
            !response.data ||
            !response.data.data ||
            !Object.keys(response.data.data).length
          ) {
            this.$notify.error({
              title: "Error",
              message: "Unable to get match data.",
            });
            this.$store.commit("LOADING", false);
            this.$router.go(-1);
          } else {
            this.$store.commit("match/CURRENT_MATCH", response.data.data);
            this.$store.commit("LOADING", false);
          }
        })
        .catch((e) => {
          this.$notify.error({
            title: "Error",
            message:
              e.response && e.response.data && e.response.data.message
                ? e.response.data.message
                : "There has been an error",
          });
          this.$store.commit("LOADING", false);
        });
    },
    matchDate(dateTime) {
      return moment(dateTime).format("dddd Do MMMM");
    },
    matchTime(dateTime) {
      return moment(dateTime).format("h:mma");
    },
    matchList() {
      this.$router.push({ name: "matches" });
    },
    getHomePlayer(position) {
      if (this.currentHomeTeam) {
        return this.getPlayer(position, this.currentHomeTeam);
      }
      return "";
    },
    getAwayPlayer(position) {
      if (this.currentAwayTeam) {
        return this.getPlayer(position, this.currentAwayTeam);
      }
      return "";
    },
    getPlayer(position, currentTeam) {
      const foundPlayer = currentTeam.find(
        (p) => p.position.number === position.number,
      );

      return foundPlayer
        ? `${foundPlayer.shirtNum} ${foundPlayer.firstName} ${
            foundPlayer.lastName
          } ${foundPlayer.isCaptain ? "(c)" : ""}`
        : "";
    },
    back() {
      this.$router.push({ name: "matches" });
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.card {
  margin-bottom: 20px;
}

.rel {
  position: relative;

  @media (max-width: 400px) {
    margin-top: 20px;
  }
}

.justify-center {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.scores {
  width: 100%;

  .section {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;

    .row {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-top: 20px;

      .score {
        font-size: 1.2rem;
        font-weight: bold;
        align-self: flex-end;
      }

      .heading {
        margin: 0px 25px;
        h3 {
          font-size: 1.2rem;
          font-weight: normal;
          text-transform: uppercase;
          letter-spacing: 0.2rem;
          margin: 0px;
        }
      }

      .detail {
        width: 50%;
        text-align: right;
        padding-right: 10px;

        & + .detail {
          text-align: left;
          padding-left: 10px;
          padding-right: 0px;
          border-left: 1px solid darkgray;
        }
      }
    }
  }
}

.tabbed {
  .tablist {
    padding: 0px 10px 10px 10px;
    width: 100%;
    display: flex;
    justify-content: center;

    li {
      padding: 0px 10px;
      list-style: none;
      font-weight: bold;
      color: darkgray;

      &:focus {
        outline: none !important;
      }

      &[aria-selected="true"] {
        color: $black;
        border-bottom: 3px solid $primary;
      }
    }
  }

  .panel {
    display: flex;
    @media (max-width: 400px) {
      flex-direction: column;
    }
    margin-bottom: 20px;

    &[aria-hidden="true"] {
      display: none;
    }

    table.desktop {
      @media (max-width: 400px) {
        display: none;
      }
      display: auto;
      width: 80%;
      margin: auto;
      border-spacing: 0;
      border-collapse: collapse;

      th {
        font-size: 1.1rem;
      }

      th,
      td {
        padding: 10px 4px 4px 4px;
      }

      // Column 1
      th:nth-child(1),
      td:nth-child(1) {
        width: 40%;
        text-align: right;
      }

      // Column 2
      td:nth-child(2) {
        text-align: center;
        font-weight: bold;
      }

      // Column 3
      th:nth-child(3),
      td:nth-child(3) {
        width: 40%;
        text-align: left;
      }
    }

    table.mobile {
      @media (max-width: 400px) {
        display: inline;
      }
      display: none;
      width: 80%;
      margin: auto;
      margin-bottom: 20px;
      border-spacing: 0;
      border-collapse: collapse;

      th {
        font-size: 1.1rem;
      }

      th,
      td {
        padding: 10px 4px 4px 4px;
      }

      // Column 1
      th:nth-child(1),
      td:nth-child(1) {
        width: 60%;
        text-align: left;
        font-weight: bold;
      }

      // Column 2
      td:nth-child(2) {
        width: 40%;
        text-align: left;
      }
    }
    .column {
      @media (max-width: 400px) {
        width: 100%;
      }
      display: flex;
      flex-direction: column;
      width: 50%;
      text-align: left;

      .interchange {
        display: flex;
        align-items: center;

        > div {
          margin: 10px;
        }

        .counts,
        .time,
        .header,
        .player > span {
          font-weight: bold;
        }

        @media (max-width: 400px) {
          margin-bottom: 10px;
          width: 100%;

          .counts,
          .time {
            text-align: center;
          }

          > div {
            margin-bottom: 0px;

            > div {
              margin: 3px;
            }
          }
        }
      }

      & + .column {
        align-items: flex-end;
        border-left: 1px solid darkgray;

        @media (max-width: 400px) {
          border-left: none;
        }

        .interchange {
          width: 100%;
          text-align: right;
          flex-direction: row-reverse;
          @media (max-width: 400px) {
            flex-direction: row;
            text-align: left;
          }
        }

        .counts,
        .time {
          text-align: right;

          @media (max-width: 400px) {
            text-align: center;
          }
        }
      }

      &.mobile-header {
        display: none;
        @media (max-width: 400px) {
          display: inline;
        }
      }
    }
  }
}

.mobile-header {
  font-size: 1.1rem;
  text-align: left;
  font-weight: bold;
  margin: 10px;
  margin-top: 30px;
  display: none;
  @media (max-width: 400px) {
    display: inline;
  }
}

.tl-data {
  text-transform: capitalize;
  font-weight: bold;
}
</style>
